import PriceAnn from '@/blocks/Price/PriceAnn'
import PriceBanner from '@/blocks/Price/PriceBanner'
import PriceRec from '@/blocks/Price/PriceRec'
import PriceDynamic from '@/blocks/Price/PriceDynamic'
import PriceChart from '@/blocks/Price/PriceChart'
import PriceFuture from '@/blocks/Price/PriceFuture'
import PriceFaqs from '@/blocks/Price/PriceFaqs'
import PriceLearn from '@/blocks/Price/PriceLearn'
import PriceNews from '@/blocks/Price/PriceNews'
import PriceTdk from '@/blocks/Price/PriceTdk'
import PriceTable from '@/blocks/Price/PriceTable'
import { PriceFutureEventGateLearn, PriceMainStyled, PriceAnnouncementContainer } from './style'
import { observer } from 'mobx-react-lite'
import { useStore } from '@/store/index'
import { useMount, useUpdateEffect } from 'ahooks'
import { eventNewTracker } from '@/utils/collectEvent'

const PriceLayout = () => {
  const { baseStore, globalStore } = useStore()
  const uid = globalStore.uid
  const pageType = baseStore?.pageType

  const getTracker = () => {
    eventNewTracker('price_page_view', {
      page_url: `${pageType}`.includes('/price') ? pageType : `/price/view/${pageType}`,
      uid: uid,
    })
  }

  useMount(() => {
    getTracker()
  })

  useUpdateEffect(() => {
    getTracker()
  }, [pageType, uid])

  return (
    <>
      <PriceTdk />
      <PriceMainStyled className="flex--grid--layout">
        <PriceAnnouncementContainer>
          <PriceBanner />
          <PriceRec />
          <PriceDynamic />
        </PriceAnnouncementContainer>
        <PriceChart />
        <PriceTable />
        <PriceNews />
        <PriceFutureEventGateLearn>
          <PriceFuture />
          <PriceLearn />
        </PriceFutureEventGateLearn>
        <PriceAnn />
        <PriceFaqs />
      </PriceMainStyled>
    </>
  )
}

export default observer(PriceLayout)
